<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import store from '../../../store';
import SkiPersonCategory from '../../../components/ski/school/SkiSchoolPersonCategory';
import i18n from '../../../i18n';
import TwCopyAndTranslateModal from '../../../components/TwCopyAndTranslateModal';

export default {
  name: 'SkiSchoolPersonCategories',
  components: {
    TwCopyAndTranslateModal,
    SkiPersonCategory,
  },
  data() {
    return {
      filterXmlChannel: null,
      copyAndTranslateModalOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      personCategories: 'skischool/getPersonCategories',
    }),
    ...mapState({
      season: state => state.skischool.season,
      personCategoriesLoading: state => state.skischool.season.personCategories.itemsLoading,
      personCategoriesError: state => state.skischool.season.personCategories.itemsError,
      personCategorySaveLoading: state => state.skischool.season.personCategories.saveLoading,
      personCategorySaveError: state => state.skischool.season.personCategories.saveError,
      domains: state => state.twenty.domains.items,
    }),
    isNewPersonCategoryActive() {
      return this.personCategories.some(personCategory => personCategory.id === undefined);
    },
    errorOccurred() {
      return this.personCategoriesError
        || this.personCategorySaveError;
    },
    getCopyValues() {
      const values = [];

      this.personCategories.forEach(personCategory => {
        values.push(
          {
            globalModelId: personCategory.id,
            globalModelColumnName: 'ski_school_season_person_category_id',
            selectKeyOverrides: [ 'domain_id', 'ski_school_season_person_category_id' ],
            tableName: 'domain_ski_school_season_person_category',
            sourceDomainId: null,
            selectedFromDomain: null,
            fromLanguageIsoOverride: null,
            sourceIsoOverride: null,
            disableSourceIsoOverride: true,
            toDomains: [],
            shouldTranslate: false,
            shouldCopySeo: false,
            fieldNamesAndValuesToCopyAndTranslate: [
              { name: personCategory.name },
              { domain_id: null },
              { ski_school_season_person_category_id: personCategory.id },
            ],
            title: `Person category: ${personCategory.name}`,
          },
        );
      });
      return values;
    },
  },
  methods: {
    ...mapActions({
      loadPersonCategories: 'skischool/personCategoriesByIdLoad',
      addNewPersonCategory: 'skischool/personCategoryAddNew',
      createPersonCategory: 'skischool/personCategoryCreate',
      savePersonCategory: 'skischool/personCategorySave',
      removePersonCategory: 'skischool/personCategoryRemove',
      setPersonCategory: 'skischool/setPersonCategory',
    }),
    createOrUpdate(personCategory) {
      if (personCategory.id) {
        this.savePersonCategory(personCategory);
      } else {
        this.createPersonCategory(personCategory);
      }
    },
    remove(personCategoryId) {
      // eslint-disable-next-line no-alert
      if (!personCategoryId || confirm(i18n.t('ski.skiPersonCategory.removeAreYouSure'))) {
        this.removePersonCategory(personCategoryId);
      }
    },
    onPersonCategoryChange(payload) {
      this.setPersonCategory(payload);
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seasonId) {
      store.dispatch('skischool/personCategoriesByIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container class="pa-0">
    <div>
      <h2 class="d-inline-block">
        {{ $t('ski.skiPersonCategories.title') }}
        ({{ Object.keys(personCategories).length }})
      </h2>
      <v-btn
        :disabled="isNewPersonCategoryActive
          || personCategoriesLoading
          || personCategorySaveLoading
        "
        class="mb-2"
        color="success"
        outline
        @click="addNewPersonCategory"
      >
        {{ $t('ski.skiPersonCategories.new') }}
      </v-btn>
      <v-btn
        :loading="personCategoriesLoading"
        icon
        @click="loadPersonCategories(season.id)"
      >
        <v-icon>cached</v-icon>
      </v-btn>
      <v-btn
        v-if="personCategories.some(category => category.id)"
        :loading="personCategoriesLoading"
        color="primary success"
        @click="copyAndTranslateModalOpen = !copyAndTranslateModalOpen"
      >
        Copy/translate
      </v-btn>
      <tw-copy-and-translate-modal
        v-if="copyAndTranslateModalOpen"
        :elements-to-handle="getCopyValues"
        :domains="domains"
      />
    </div>
    <div class="text-center">
      <v-progress-linear
        v-if="personCategoriesLoading || personCategorySaveLoading"
        :indeterminate="true"
      />
    </div>
    <v-alert
      :value="errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"/>
    </v-alert>
    <v-layout v-if="personCategories.length" wrap>
      <v-flex sm2 xs12 offset-sm1>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiPersonCategory.nameSupplier') }}</p>
      </v-flex>
      <v-flex sm2 xs12>
        <p class="font-weight-bold pl-2 pt-2"> Global Name </p>
      </v-flex>
      <v-flex sm2 xs12>
        <p class="font-weight-bold pl-2 pt-2"> Domain Name </p>
      </v-flex>
      <v-flex sm1 xs12>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiPersonCategory.ageFrom') }}</p>
      </v-flex>
      <v-flex sm1 xs12>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiPersonCategory.ageTo') }}</p>
      </v-flex>
      <v-flex sm2 xs12/>
    </v-layout>
    <v-layout
      v-for="(personCategory) in personCategories"
      :key="'ski-person-category-' + personCategory.id"
      :loading="personCategoriesLoading"
      xs12
    >
      <ski-person-category
        :category="personCategory"
        :save-loading="personCategorySaveLoading"
        @createOrUpdate="createOrUpdate"
        @remove="remove"
      />
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/school/SkiSchoolSeasonPersonCategories.vue